import { ConnectError } from '@connectrpc/connect'
import { createConnectQueryKey } from '@connectrpc/connect-query'
import type { WorkflowCaseConflict } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import { WorkflowCaseConflictSchema } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'
import {
  createWorkflowCases,
  listWorkflowCases,
  listWorkflowTagPool,
} from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * CreateWorkflowCases mutation hook。
 * N×M 一括作成 (spec AC-003b)。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 * タグプール (AC-TAG-005) も invalidate する — 新規タグが org 全体のプールに
 * 加わりうるため、他画面のサジェスト・20 個上限チェックを最新化する。
 */
export function useCreateWorkflowCases(): InvalidatingMutationResultFor<
  typeof createWorkflowCases
> {
  return useInvalidatingMutation(createWorkflowCases, [
    createConnectQueryKey({ schema: listWorkflowCases, cardinality: 'finite' }),
    createConnectQueryKey({
      schema: listWorkflowTagPool,
      cardinality: 'finite',
    }),
  ])
}

/**
 * ConnectError から WorkflowCaseConflict error detail を抽出する。
 * bff は FailedPrecondition で返し、detail に WorkflowCaseConflict[] を詰める。
 * detail が取れない場合は空配列を返す。
 */
export function extractConflictDetails(
  err: ConnectError,
): WorkflowCaseConflict[] {
  try {
    return err.findDetails(WorkflowCaseConflictSchema)
  } catch {
    return []
  }
}
